<template>
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5625 0.874512C3.18008 0.874512 0.4375 3.61709 0.4375 6.99951C0.4375 10.3819 3.18008 13.1245 6.5625 13.1245C9.94492 13.1245 12.6875 10.3819 12.6875 6.99951C12.6875 3.61709 9.94492 0.874512 6.5625 0.874512ZM6.5625 12.0854C3.7543 12.0854 1.47656 9.80772 1.47656 6.99951C1.47656 4.19131 3.7543 1.91357 6.5625 1.91357C9.3707 1.91357 11.6484 4.19131 11.6484 6.99951C11.6484 9.80772 9.3707 12.0854 6.5625 12.0854Z"
      fill="white"
    />
    <path
      d="M5.90604 9.40576C5.90604 9.57981 5.97518 9.74673 6.09825 9.8698C6.22132 9.99287 6.38824 10.062 6.56229 10.062C6.73633 10.062 6.90325 9.99287 7.02632 9.8698C7.1494 9.74673 7.21854 9.57981 7.21854 9.40576C7.21854 9.23171 7.1494 9.06479 7.02632 8.94172C6.90325 8.81865 6.73633 8.74951 6.56229 8.74951C6.38824 8.74951 6.22132 8.81865 6.09825 8.94172C5.97518 9.06479 5.90604 9.23171 5.90604 9.40576ZM6.23416 7.87451H6.89041C6.95057 7.87451 6.99979 7.82529 6.99979 7.76514V4.04639C6.99979 3.98623 6.95057 3.93701 6.89041 3.93701H6.23416C6.17401 3.93701 6.12479 3.98623 6.12479 4.04639V7.76514C6.12479 7.82529 6.17401 7.87451 6.23416 7.87451Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>



// WEBPACK FOOTER //
// WarningCircle.vue?67d1f503